/**
 * テーマオプション/スライダー
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.BACKYARD_ENDPOINT}/theme_option`

const theme_option_slide = {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        index () {
            return new Promise((resolve) => {
                const api_path = `${API_PATH}/slides`
                Vue.$http.get(api_path).then(data => {
                    const content = data.content
                    resolve(content)
                })
            })
        },
        update ({ commit }, { params }) {
            const api_path = `${API_PATH}/form_slide`
            return new Promise( ( resolve, _reject) => {
                Vue.$http.patch(api_path, params,{ headers: { 'content-type': 'multipart/form-data' } }).then( data => {
                    commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
                    resolve(data.content)
                } )
            })
        },
    },
    mutations: {},
}

export default theme_option_slide